export const buttonVariant = {
  primary: 'Primary',
  neutral: 'Neutral',
  secondary: 'Secondary',
  plain: 'Plain'
} as const;

export const buttonSize = {
  small: 'Small',
  medium: 'Medium',
  large: 'Large'
} as const;
